/**
Project: Voice Panel (c)
Title: App Constants 
Description: Contants of Application 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
export const AppConstants = {
  APP_NAME: "Voice Panel",
  CLIENT_NAVIGATOR: {
    ACCESS_MODE_TEAMS_CLIENT: "TeamsClient",
    ACCESS_MODE_TEAMS_BROWSER: "TeamsBrowser",
    ACCESS_MODE_REGULAR_BROWSER: "RegularBrowser",
  },
  SIGIN_IN: {
    FORBIDDEN_ERROR_MESSAGES: {
      ADMIN_PRIVILEGES: "E10004",
      ADMIN_CONSENT: "E10009",
      LYNC_RESOURCE: "E10010",
      SIGNIN_DIRECTORY: "E10011",
    },
  },
  MICROSOFT_ERROR_CODE: {
    AUTHORIZATiON_IDENTITY_NOT_FOUND: "Authorization_IdentityNotFound",
    AUTHORIZATiON_REQUEST_DENIED: "Authorization_RequestDenied",
  },
  SIPPIO_SUPPORT_EMAIL: "support@Sippio.io",
};
